export const Company = {
	name: null,
};
